import { __awaiter, __generator } from "tslib";
import Vue from 'vue';
var m = {
  namespaced: true,
  state: function state() {
    return {
      reportList: [],
      categoryList: null,
      questionList: {
        hot: []
      },
      qrcode: {}
    };
  },
  mutations: {
    setCategoryList: function setCategoryList(state, categoryList) {
      state.categoryList = categoryList;
    },

    /**
     * 获得问题列表
     */
    setQuestionList: function setQuestionList(state, _a) {
      var categoryId = _a.categoryId,
          isHot = _a.isHot,
          questionList = _a.questionList;

      if (isHot) {
        Vue.set(state.questionList, 'hot', questionList);
      } else {
        Vue.set(state.questionList, categoryId, questionList);
      }
    },

    /**
     * 记录report
     */
    setReportList: function setReportList(state, reports) {
      state.reportList = reports;
    },

    /**
     * 记录qrcode
     */
    setQrcode: function setQrcode(state, _a) {
      var activityId = _a.activityId,
          qrcode = _a.qrcode;
      Vue.set(state.qrcode, activityId, qrcode);
    }
  },
  actions: {
    /**
     * 获得category列表
     */
    getCategoryList: function getCategoryList(_a) {
      var state = _a.state,
          commit = _a.commit;
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_b) {
          switch (_b.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/question/category_list')];

            case 1:
              response = _b.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                commit('setCategoryList', rdata.data);
              }

              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },
    getQuestionList: function getQuestionList(_a, _b) {
      var state = _a.state,
          commit = _a.commit;
      var categoryId = _b.categoryId,
          isHot = _b.isHot,
          forceUpdate = _b.forceUpdate;
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_c) {
          switch (_c.label) {
            case 0:
              if (state.questionList[categoryId] && !forceUpdate) {
                return [2
                /*return*/
                ];
              }

              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/question/question_list', {
                params: {
                  category_id: categoryId,
                  is_hot: isHot
                }
              })];

            case 1:
              response = _c.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                commit('setQuestionList', {
                  categoryId: categoryId,
                  isHot: isHot,
                  questionList: rdata.data
                });
              }

              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 上报数据
     * @param attachments [fileId]
     */
    report: function report(_a, _b) {
      var state = _a.state,
          commit = _a.commit,
          dispatch = _a.dispatch;
      var contact = _b.contact,
          type = _b.type,
          content = _b.content,
          attachments = _b.attachments,
          signInId = _b.signInId;
      return __awaiter(this, void 0, void 0, function () {
        var response;
        return __generator(this, function (_c) {
          switch (_c.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.post('/api/v1/question/feedback', {
                contact: contact,
                type: type,
                content: content,
                attachments: attachments,
                sign_in_id: signInId
              })];

            case 1:
              response = _c.sent();
              return [2
              /*return*/
              , response.data];
          }
        });
      });
    },

    /**
     * 获取反馈列表
     */
    getReportList: function getReportList(_a) {
      var state = _a.state,
          commit = _a.commit;
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_b) {
          switch (_b.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/question/feedback')];

            case 1:
              response = _b.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                commit('setReportList', rdata.data);
              }

              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 查询
     */
    query: function query(_a, _b) {
      var state = _a.state,
          commit = _a.commit;
      var word = _b.word;
      return __awaiter(this, void 0, void 0, function () {
        var response;
        return __generator(this, function (_c) {
          switch (_c.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/question/query', {
                params: {
                  word: word
                }
              })];

            case 1:
              response = _c.sent();
              return [2
              /*return*/
              , response.data];
          }
        });
      });
    },

    /**
     * 获取二维码
     */
    getQrcode: function getQrcode(_a, _b) {
      var state = _a.state,
          commit = _a.commit;
      var activityId = _b.activityId;
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_c) {
          switch (_c.label) {
            case 0:
              if (state.qrcode[activityId]) {
                return [2
                /*return*/
                ];
              }

              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/question/question_qr_code', {
                params: {
                  activity_id: activityId
                }
              })];

            case 1:
              response = _c.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                commit('setQrcode', {
                  activityId: activityId,
                  qrcode: rdata.data ? rdata.data.qr_code : null
                });
              }

              return [2
              /*return*/
              , rdata];
          }
        });
      });
    }
  }
};
export default m;